
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","viewBox":"0 0 45 45","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M33.668 19.176c-.027 0-1.691-.021-2.788-1.11-.679-.674-1.024-1.652-1.025-2.876.007-.189.108-1.843 1.738-1.843.425 0 .739.121.991.382.628.649.725 1.991.709 2.453l1.998.068c.015-.419.021-2.577-1.269-3.911-.627-.649-1.467-.992-2.429-.992-2.118 0-3.193 1.44-3.57 2.811H16.102c-.372-1.359-1.447-2.811-3.574-2.811-.961 0-1.799.342-2.426.99-1.288 1.33-1.287 3.491-1.273 3.911l1.998-.064c-.014-.464.084-1.809.711-2.456.251-.26.567-.381.99-.381 1.571 0 1.723 1.541 1.737 1.81 0 3.896-3.427 4.018-3.821 4.019-4.163 0-4.428-3.891-4.444-4.301 0-2.804 1.522-3.748 2.947-4.414.809-.377 1.65-.398 1.643-.398h22.926c.008 0 .849.021 1.658.399 1.426.665 2.947 1.609 2.948 4.38-.017.443-.283 4.334-4.454 4.334zM15.213 8.063h13.583V6.796H15.213v1.267zm-1.992-3.267h17.821V3H13.221v1.796zM36.02 8.65c1.227.572 4.101 1.913 4.101 6.225-.063 2.198-1.492 6.301-6.445 6.301h-.009a6.838 6.838 0 01-2.784-.693v24.026h-2v-25.75c-.508-.732-.822-1.603-.947-2.601H16.184c-.126 1.004-.441 1.873-.947 2.602v25.749h-2V20.484c-1.384.687-2.729.691-2.8.692-4.947 0-6.373-4.103-6.437-6.272 0-4.341 2.874-5.682 4.102-6.255a6.517 6.517 0 012.476-.586h2.635V6.796h-1.992V1h21.821v5.796h-2.246v1.267h2.735c.14.001 1.298.03 2.489.587zM23.906 44.46V19.106h2V44.46h-2zm-5.886 0V19.105h2.001V44.46H18.02z","fill":"#020203","fill-rule":"evenodd"}})])
          )
        }
      }
    